import React, { FC } from 'react'
import * as SC from './styled'

export interface InputProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  name?: string
  value?: string
  placeholder?: string
  error?: string
  onBlur?: (event: React.FocusEvent<HTMLElement>) => void
  disabled?: boolean
  onFocus?: (event: React.FocusEvent<HTMLElement>) => void
  type?: string
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  autoComplete?: string
  prefixIcon?: JSX.Element
  clearInput?: (event: React.SyntheticEvent<HTMLElement>) => void;
}

const InputComponent: FC<InputProps> = props => {
  const {
    onChange,
    name,
    value,
    placeholder,
    error,
    onBlur,
    disabled,
    onFocus,
    type,
    icon,
    autoComplete,
    prefixIcon,
    clearInput
  } = props

  return (
    <SC.Base>
      <SC.InputBlock error={error} icon={icon} disabled={disabled} hasPrefixIcon={!!prefixIcon}>
        {prefixIcon && <SC.PrefixIconWrapper>{prefixIcon}</SC.PrefixIconWrapper>}
        <SC.Input
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          type={type || 'text'}
          autoComplete={autoComplete}
        />
        {clearInput && value ? <SC.ClearButton onClick={clearInput}/>  : ''}
      </SC.InputBlock>
    </SC.Base>
  )
}

export default InputComponent
